const crud = { c: false, r: false, u: false, d: false };

export const admins = Object.freeze({
  admin: { ...crud },
});
